<template>
  <div class="laporan" :class="{ 'animate-flicker' : loadingToko }">
    <div>
      <h2>Pengaturan Toko</h2>

      <br />

      <div class="tab">
        <ul>
          <li>
            <a
              href="javascript:void(0)"
              :class="{ active: tabActive == 'toko' }"
              @click="setTabActive('toko')"
            >
              Toko
            </a>
          </li>
          <li>
            <a
              href="javascript:void(0)"
              :class="{ active: tabActive == 'profil' }"
              @click="setTabActive('profil')"
            >
              Profil
            </a>
          </li>
          <li>
            <a
              href="javascript:void(0)"
              :class="{ active: tabActive == 'password' }"
              @click="setTabActive('password')"
            >
              Password
            </a>
          </li>
        </ul>
      </div>

      <div class="grid">
        <div v-show="tabActive == 'toko'">
          <form @submit.prevent="saveToko()">
            <div class="form-group">
              <label>Nama Bisnis</label>
              <input type="text" v-model="data.toko.nama" />
            </div>
            <div class="form-group">
              <label>No Telp</label>
              <input type="tel" v-model="data.toko.no_telp" />
            </div>
            <div class="form-group">
              <label>Alamat</label>
              <textarea v-model="data.toko.alamat" rows="4"></textarea>
            </div>
            <div class="form-group">
              <label>Jenis Produk</label>
              <select v-model="data.toko.jenis_produk">
                <option
                  v-for="(item, index) in data.jenisProduk"
                  :key="index"
                  :value="item.nama"
                >
                  {{ item.nama }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <button type="submit" class="btn-fill" :disabled="loadingToko">
                {{ loadingToko ? "Menyimpan..." : "Simpan" }}
              </button>
            </div>
          </form>
        </div>
        <div v-show="tabActive == 'profil'">
          <form @submit.prevent="saveUser()">
            <div class="form-group">
              <label>Nama Pemilik</label>
              <input type="text" v-model="data.user.nama" />
            </div>
            <div class="form-group">
              <label>No Telp</label>
              <input type="tel" v-model="data.user.no_telp" />
            </div>
            <div class="form-group">
              <label>Email</label>
              <input
                type="email"
                v-model="data.user.username"
                disabled
                style="background-color: #f4f4f4"
              />
            </div>
            <div class="form-group">
              <button type="submit" class="btn-fill" :disabled="loadingUser">
                {{ loadingUser ? "Menyimpan..." : "Simpan" }}
              </button>
            </div>
          </form>
        </div>
        <div v-show="tabActive == 'password'">
          <form @submit.prevent="updatePassword()">
            <div class="form-group">
              <label>Password Lama</label>
              <input type="password" v-model="data.password.current_password" />
            </div>
            <div class="form-group">
              <label>Password Baru</label>
              <input type="password" v-model="data.password.new_password" />
            </div>
            <div class="form-group">
              <label>Konfirmasi Password</label>
              <input type="password" v-model="data.password.confirm_password" />
            </div>
            <div class="form-group">
              <button
                type="submit"
                class="btn-fill"
                :disabled="loadingPassword"
              >
                {{ loadingPassword ? "Menyimpan..." : "Simpan" }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import * as api from "./../../api/Api";

export default {
  name: "Home",
  components: {},
  data() {
    return {
      loadingToko: false,
      loadingUser: false,
      loadingPassword: false,

      tabActive: "toko",
      data: {
        toko: {},
        user: {},
        password: {},
        jenisProduk: [],
      },
    };
  },
  methods: {
    setTabActive(val) {
      this.tabActive = val;
    },
    async loadToko() {
      this.loadingToko = true;

      const toko = await api.get("/v4/toko?id=" + this.$toko.id);
      this.data.toko = toko.data;
      this.data.jenisProduk = toko.data_jenis_produk;

      this.loadingToko = false;
    },
    async saveToko() {
      this.loadingToko = true;
      const res = await api.post("/v4/toko/save", this.data.toko);
      if (res.valid) {
        this.$toast("Berhasil diupdate");
      }
      this.loadingToko = false;
    },

    async loadUser() {
      const res = await api.get(
        "/v4/setting/user?id=" + this.$user.id + "&id_toko=" + this.$toko.id
      );
      this.data.user = res.data;
    },
    async saveUser() {
      this.loadingUser = true;
      const res = await api.post("/v4/setting/user/save", this.data.user);
      if (res.valid) {
        this.$toast("Berhasil diupdate");
      }
      this.loadingUser = false;
    },

    async updatePassword() {
      if (
        !this.data.password.current_password ||
        !this.data.password.new_password
      ) {
        this.$toast("Password harus diisi ya");
        return;
      }

      if (
        this.data.password.new_password != this.data.password.confirm_password
      ) {
        this.$toast("Konfirmasi password tidak sama");
        return;
      }

      this.data.password.id = this.$user.id;

      this.loadingPassword = true;
      const res = await api.post(
        "/v4/setting/user/password",
        this.data.password
      );
      if (res.valid) {
        this.$toast("Berhasil diupdate");
      } else {
        this.$toast(res.message);
      }
      this.loadingPassword = false;
    },
  },
  mounted() {
    this.loadToko();
    this.loadUser();
  },
};
</script>
  
  <style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
  }

  .tab {
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: flex;

      li {
        a {
          display: block;
          padding: 10px 20px;
          text-decoration: none;
          color: #333;
          text-transform: uppercase;
          font-size: 14px;
          &.active {
            color: var(--primary);
            border-bottom: 2px solid var(--primary);
          }
          &:hover {
            color: var(--primary);
          }
          &:active {
            background-color: #f8f8f8;
          }
        }
      }
    }
  }

  .grid {
    form {
      width: 400px;
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/Pengaturan/Toko.vue